import React, {useCallback, useEffect, useState} from "react";
import {SaleService} from "../sale/sale.service";
import {changePageTitle, setAlert} from "../typescript/redux/actions";
import {useDispatch} from "react-redux";
import {Datatable} from "../index";
import SaleAfterListForm from "./sale-after-list-form";
import {
    Edit,
    GetApp,
    LocalShipping,
    Payment,
    Phone,
    Publish,
    Star, StarBorder,
    ThumbDown,
    ThumbUp,
    Warning
} from "@mui/icons-material";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import {IconButton, Tooltip} from "@mui/material";
import {useNavigate} from "react-router-dom";
import {AuthService} from "../typescript/auth/auth.service";
import ButtonSelect from "../typescript/button-select/button-select";
import {DeliveryQrCodeAction} from "./delivery-qr-code-action";

export function SaleAfterList() {
    let navigate = useNavigate();
    const dispatch = useDispatch();
    const [items, setItems] = useState(SaleService.createSalesClosedResponse());
    const isAdmin = AuthService.userInRole("ADMIN");

    const findAll = useCallback(async (startDateParam, endDateParam, idParam, personNameParam) => {
        const result = await SaleService.findAllClosed(startDateParam, endDateParam, idParam, personNameParam);
        setItems(result);
    }, []);

    useEffect(() => {
        dispatch(changePageTitle("Pós Vendas (Só aparecem vendas fechadas)"));
    }, [dispatch]); // eslint-disable-line react-hooks/exhaustive-deps

    const deliverById = (saleId) => {
        return SaleService.delivery(saleId).then(() => {
            dispatch(setAlert({show: true, message: 'Venda entregue com sucesso', severity: 'success'}));
            goToReceivables(saleId);
        }).catch((error) => {
            dispatch(setAlert({
                show: true,
                message: 'Erro ao entregar venda - ' + error.data.message,
                severity: 'error'
            }));
        })
    }

    const delivery = (item) => {
        if (!item) {
            return;
        }
        deliverById(item.id);
    }

    const advice = (item) => {
        SaleService.advice(item.id).then(() => {
            dispatch(setAlert({show: true, message: 'Venda avisada com sucesso', severity: 'success'}));
            updateItemAdviced(item);
        }).catch((error) => {
            dispatch(setAlert({
                show: true,
                message: 'Erro ao avisar venda - ' + error.data.message,
                severity: 'error'
            }));
        })
    }

    const cancelDelivery = (item) => {
        if (item.status3) {
            dispatch(setAlert({
                show: true,
                message: 'Não é possível cancelar a entrega de uma venda que já possui status',
                severity: 'error'
            }));
            return;
        }
        SaleService.cancelDelivery(item.id).then(() => {
            dispatch(setAlert({show: true, message: 'Entrega cancelada com sucesso', severity: 'success'}));
            updateItemDelivered(item);
        }).catch((error) => {
            dispatch(setAlert({
                show: true,
                message: 'Erro ao cancelar entrega - ' + error.data.message,
                severity: 'error'
            }));
        })
    }

    const cancelAdvice = (item) => {
        if (item.delivery) {
            dispatch(setAlert({
                show: true,
                message: 'Não é possível cancelar o aviso de uma venda que já foi entregue',
                severity: 'error'
            }));
            return;
        }
        SaleService.cancelAdvice(item.id).then(() => {
            dispatch(setAlert({show: true, message: 'Aviso cancelado com sucesso', severity: 'success'}));
            updateItemAdviced(item);
        }).catch((error) => {
            dispatch(setAlert({
                show: true,
                message: 'Erro ao cancelar aviso - ' + error.data.message,
                severity: 'error'
            }));
        })
    }

    const updateItemReceipt = (item) => {
        let salesToChange = [...items.sales];
        for (let saleToChange of salesToChange) {
            if (saleToChange.id === item.id) {
                saleToChange.receipt = !saleToChange.receipt;
                break;
            }
        }
        setItems({
            ...items,
            sales: salesToChange
        })
    }

    const updateItemDelivered = (item) => {
        let salesToChange = [...items.sales];
        for (let saleToChange of salesToChange) {
            if (saleToChange.id === item.id) {
                saleToChange.delivery = !saleToChange.delivery;
                break;
            }
        }
        setItems({
            ...items,
            sales: salesToChange
        })
    }

    const updateItemAdviced = (item) => {
        let salesToChange = [...items.sales];
        for (let saleToChange of salesToChange) {
            if (saleToChange.id === item.id) {
                saleToChange.advice = !saleToChange.advice;
                break;
            }
        }
        setItems({
            ...items,
            sales: salesToChange
        })
    }

    const goToReceivables = (saleId) => {
        navigate('/sales/after/' + saleId + '/receivables');
    }

    const goToPayables = (saleId) => {
        navigate('/sales/after/' + saleId + '/payables');
    }

    const canDeliver = (item) => {
        return !!item && item.advice && !item.delivery;
    }

    const deliverByQrCode = (saleId) => {
        const item = items.sales.find((sale) => Number(sale.id) === saleId);
        if (!canDeliver(item)) {
            dispatch(setAlert({
                show: true,
                message: 'Não é possível entregar essa venda',
                severity: 'error'
            }));
            return Promise.resolve();
        }

        return deliverById(saleId);
    }


    const receipt = (item) => {
        SaleService.recebe(item.id).then(() => {
            dispatch(setAlert({show: true, message: 'Venda recebida com sucesso', severity: 'success'}));
            if (isAdmin) {
                goToPayables(item.id);
            } else {
                updateItemReceipt(item);
            }
        }).catch((error) => {
            dispatch(setAlert({
                show: true,
                message: 'Erro ao receber venda - ' + error.data.message,
                severity: 'error'
            }));
        })
    }

    const cancelReceipt = (item) => {
        if (item.advice) {
            dispatch(setAlert({
                show: true,
                message: 'Não é possível cancelar o recebimento de uma venda que já foi avisada',
                severity: 'error'
            }));
            return;
        }
        SaleService.cancelaRecebimento(item.id).then(() => {
            dispatch(setAlert({show: true, message: 'Recebimento cancelado com sucesso', severity: 'success'}));
            updateItemReceipt(item);
        }).catch((error) => {
            dispatch(setAlert({
                show: true,
                message: 'Erro ao cancelar recebimento - ' + error.data.message,
                severity: 'error'
            }));
        })
    }

    const status3 = [
        {id: null, descricao: 'Neutro', icon: <Edit/>, color: "error"},
        {id: 'SE_ADAPTOU_BEM', descricao: 'Se adaptou bem', icon: <ThumbUp/>, color: "primary"},
        {id: 'AINDA_NAO_SE_ADAPTOU', descricao: 'Ainda não se adaptou', icon: <Warning/>, color: "warning"},
        {id: 'NAO_SE_ADAPTOU', descricao: 'Não se adaptou', icon: <ThumbDown/>, color: "error"},
        {id: 'VAI_LEVAR_AO_MEDICO', descricao: 'Vai levar ao médico', icon: <Warning/>, color: "warning"},
        {id: 'NAO_RETORNOU', descricao: 'Não retornou', icon: <Warning/>, color: "warning"}
    ]

    const renderStars = (count, color) => {
        const stars = [];
        for (let i = 0; i < 5; i++) {
            stars.push(i < count ? <Star key={i} color={color}/> : <StarBorder key={i} color="disabled"/>);
        }
        return stars;
    };

    const notaGoogle = [
        {id: null, descricao: '0', icon: renderStars(0, "error"), color: "error"},
        {id: 1, descricao: '1', icon: renderStars(1, "error"), color: "error"},
        {id: 2, descricao: '2', icon: renderStars(2, "warning"), color: "warning"},
        {id: 3, descricao: '3', icon: renderStars(3, "warning"), color: "warning"},
        {id: 4, descricao: '4', icon: renderStars(4, "primary"), color: "primary"},
        {id: 5, descricao: '5', icon: renderStars(5, "primary"), color: "primary"}
    ]

    const onChangeStatus3 = async (newStatus3, item) => {
        SaleService.updateStatus3(item.id, newStatus3).then(function (result) {
            let itemsToChange = {...items};
            for (let i = 0; i < itemsToChange.sales.length; i++) {
                if (itemsToChange.sales[i].id === item.id) {
                    itemsToChange.sales[i] = result.data;
                    break;
                }
            }
            setItems(itemsToChange);
        }, (error) => {
            dispatch(setAlert({show: true, message: error.data.message, severity: 'error'}));
        });
    }

    const onChangeNotaGoogle = async (notaGoogle, item) => {
        SaleService.updateNotaGoogle(item.id, notaGoogle).then(function (result) {
            let itemsToChange = {...items};
            for (let i = 0; i < itemsToChange.sales.length; i++) {
                if (itemsToChange.sales[i].id === item.id) {
                    itemsToChange.sales[i] = result.data;
                    break;
                }
            }
            setItems(itemsToChange);
        }, (error) => {
            dispatch(setAlert({show: true, message: error.data.message, severity: 'error'}));
        });
    }

    const renderDescriptionStatus3 = (id) => {
        const itemSelected = status3.filter(item => item.id === id);
        if (itemSelected[0]) {
            return itemSelected[0].descricao;
        }
    }

    const renderDescriptionNotaGoogle = (id) => {
        const itemSelected = notaGoogle.filter(item => item.id === id);
        if (itemSelected[0]) {
            return itemSelected[0].descricao;
        }
    }

    const renderStatus3 = (item, dataColumn) => {
        if (!item.delivery) {
            return (
                <ButtonSelect items={status3} id={item[dataColumn]} disabled
                              onChange={(newStatus3) => onChangeStatus3(newStatus3, item)}/>
            )
        }
        return (
            <ButtonSelect items={status3} id={item[dataColumn]}
                          onChange={(newStatus3) => onChangeStatus3(newStatus3, item)}
                          title={renderDescriptionStatus3(item[dataColumn])}/>
        )
    }

    const renderNotaGoogle = (item, dataColumn) => {
        return (
            <ButtonSelect items={notaGoogle} id={item[dataColumn]}
                          onChange={(newNotaGoogle) => onChangeNotaGoogle(newNotaGoogle, item)}
                          title={renderDescriptionNotaGoogle(item[dataColumn])}/>
        )
    }

    const renderPayableDocuments = (item) => {
        return isAdmin && (
            <Tooltip color='primary' title={"Documentos a pagar"}>
                <IconButton onClick={() => goToPayables(item.id)}>
                    <Payment/>
                </IconButton>
            </Tooltip>
        )
    }

    const renderReceipt = (item) => {
        if (item.receipt) {
            const colorReceipt = item.hasOpenDocuments ? "warning" : "primary";
            return (
                <Tooltip color={colorReceipt} title={"Cancelar recebimento"}>
                    <IconButton onClick={() => cancelReceipt(item)}>
                        <Publish/>
                    </IconButton>
                </Tooltip>
            )
        }
        const colorDelivery = item.hasOpenDocuments ? "warning" : "error";
        return (
            <Tooltip color={colorDelivery} title={"Receber"}>
                <IconButton onClick={() => receipt(item)}>
                    <GetApp/>
                </IconButton>
            </Tooltip>
        )
    }

    const renderAdvice = (item) => {
        if (!item.receipt) {
            return (
                <IconButton onClick={() => cancelAdvice(item)} disabled>
                    <Phone/>
                </IconButton>
            )
        }
        if (item.advice) {
            return (
                <Tooltip color={"primary"} title={"Cancelar aviso"}>
                    <IconButton onClick={() => cancelAdvice(item)}>
                        <Phone/>
                    </IconButton>
                </Tooltip>
            )
        }
        return (
            <Tooltip color={"error"} title={"Avisar"}>
                <IconButton onClick={() => advice(item)}>
                    <Phone/>
                </IconButton>
            </Tooltip>
        )
    }

    const renderDelivery = (item) => {
        if (!item.advice) {
            return (
                <IconButton onClick={() => cancelDelivery(item)} disabled>
                    <LocalShipping/>
                </IconButton>
            )
        }
        if (item.delivery) {
            return (
                <Tooltip color={"primary"} title={"Cancelar entrega"}>
                    <IconButton onClick={() => cancelDelivery(item)}>
                        <LocalShipping/>
                    </IconButton>
                </Tooltip>
            )
        }
        return (
            <Tooltip color={"error"} title={"Entregar"}>
                <IconButton onClick={() => delivery(item)}>
                    <LocalShipping/>
                </IconButton>
            </Tooltip>
        )
    }

    const renderDeliveryQrCodeButton = () => {
        return (
            <DeliveryQrCodeAction
                onSubmitSaleId={deliverByQrCode}
                onInvalidQrCode={() => dispatch(setAlert({
                    show: true,
                    message: 'QR Code inválido para entrega',
                    severity: 'error'
                }))}
                renderTrigger={(openScanner) => (
                    <Tooltip title={"Ler QR Code para entrega"}>
                        <IconButton onClick={openScanner}>
                            <QrCodeScannerIcon/>
                        </IconButton>
                    </Tooltip>
                )}
            />
        )
    }

    const renderPayableColumn = () => {
        return isAdmin ? 'Doc a pagar' : null;
    }

    return (
        <React.Fragment>
            <SaleAfterListForm findAll={findAll} extraActions={renderDeliveryQrCodeButton()}/>
            <Datatable data={items.sales} totalData={items.sales.length}
                       dataColumnNames={['ID Venda', 'Cliente', 'Telefone', 'Emiss\u00E3o', 'Total', 'Data/hora fechamento', renderPayableColumn(), 'Etapa 1 (Receber)', 'Etapa 2 (Avisar)', 'Etapa 3 (Entregar)', 'Etapa 4 (Status)', 'Etapa 5 (Nota Google)']}
                       dataColumns={['id', 'person.name', 'person.phone', 'createdDate', 'total', 'finished', '', '', '', '', 'status3', 'notaGoogle']}
                       dataTypes={['number', 'text', 'text', 'date', 'currency', 'zonedatetime', 'text', 'text', 'text', 'text', 'enum', 'number']}
                       findAll={findAll}
                       dataValues={[null, null, null, null, null, null, renderPayableDocuments, renderReceipt, renderAdvice, renderDelivery, renderStatus3, renderNotaGoogle]}
                       summarize={[null, null, null, null, 'total', null, null, null, null, null, null]}/>
        </React.Fragment>
    );

}
